module.exports = __webpack_public_path__ + "static/media/linkedinIcon.004c85e8.svg";